import { useWidgetDndContextData } from 'src/context/WidgetDndContext';
import { useCheckIfHomePage } from 'src/utils/useCheckIfHomePage';

export const useNavConfigs = (isScrollable, isHeaderHovered = false) => {
  const isHomePage = useCheckIfHomePage();

  const {
    widgetContextState: { isBuilder, activeHeaderData },
  } = useWidgetDndContextData();

  const globalClass = activeHeaderData?.headerPropsConfig?.globalClass || {};
  const { staticClass, scrollClass } = globalClass || {};

  const isTransparent =
    globalClass?.staticClass?.base_config?.defaultFillColorType === 'transparent';
  const scrollType =
    activeHeaderData?.headerPropsConfig?.globalClass?.scrollClass?.base_config
      ?.defaultScrollType || '';

  const shouldUseScrollClass =
    isTransparent && (isScrollable || isHeaderHovered || (!isBuilder && !isHomePage));
  const showTransparentBgHeader = isTransparent && !shouldUseScrollClass;
  const currentClass = shouldUseScrollClass ? scrollClass : staticClass;

  return {
    isHomePage,
    isBuilder,
    globalClass,
    scrollClass,
    staticClass,
    currentClass,
    isTransparent,
    shouldUseScrollClass,
    showTransparentBgHeader,
    scrollType,
  };
};
